import { gql } from "@apollo/client";

export const MUTATION_LOGGING = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      role
      user {
        nickname
        userProfile {
          cities {
            name
          }
        }
      }
    }
  }
`;
